module.exports = __webpack_public_path__ + "img/2010 winteressen 024.80b0157e.jpg";